module.exports = __webpack_public_path__ + "media/gift/add_icon-6f5cf932.svg";